// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "2471753b" + "." + "9baee6d3df3cf0cd" + ".js";
};